import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";
import AddShift from "./AddShift";

const Shift = (props) => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	return (
		<div className="add-shift-page-wrapper">
			
			<AddShift />
		</div>
	);
};

export default Shift;
